import { createSlice } from "@reduxjs/toolkit";

const errorSlice = createSlice({
    name: 'error',
    initialState: { 
        isError: false,
        isBasketEmpty: false
    },
    reducers: {
        setError: (state, action) => {
            state.isError = action.payload || state.isError;
        },
        setBasketEmpty: (state, action) => {
            state.isBasketEmpty = action.payload || state.isBasketEmpty;
        }
    }
});

export const errorActions = errorSlice.actions;
export default errorSlice;